import React from 'react';

import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import { useMediaQuery } from 'react-responsive';
import Tabs from './components/Tabs';
import Table from './components/Table';
import FilterBases from './components/FilterBases';
import Calendar from './components/Calendar';
import TabsMobile from './components/TabsMobile';

import { useTrackingRefuel } from '../hooks/useTrackingRefuel';

import {
  Container,
  TitleWrapper,
  Title,
  Subtitle,
  FilterWrapper,
  TabAll,
  TabAllTitle,
  FilterItemsWrapper,
  TabsWrapper,
  TableWrapper,
  Count,
} from './styles';

const TrackingContainer: React.FC = () => {
  const { activeTab, handleActiveTab, counterData } = useTrackingRefuel();

  const conterAll = counterData?.total ?? 0;

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Navbar selected="tracking" openSubMenu="abastecimento">
      <UserMenu intro={() => true} />
      <Container>
        <TitleWrapper>
          <Title>Histórico de pedidos</Title>
          <Subtitle>
            Visualize todos os seus pedidos por aqui e tenha acesso aos detalhes
            de cada um.
          </Subtitle>
        </TitleWrapper>
        <FilterWrapper>
          {!isMobile && (
            <TabAll
              active={activeTab === 0}
              onClick={() => handleActiveTab && handleActiveTab(0)}
            >
              <TabAllTitle active={activeTab === 0}>Todos</TabAllTitle>
              {!!conterAll && <Count>{conterAll}</Count>}
            </TabAll>
          )}
          <FilterItemsWrapper>
            <Calendar />
            <FilterBases />
          </FilterItemsWrapper>
        </FilterWrapper>
        {!isMobile && (
          <TabsWrapper>
            <Tabs activeTab={activeTab} handleActiveTab={handleActiveTab} />
          </TabsWrapper>
        )}
        {isMobile && (
          <TabsWrapper>
            <TabsMobile
              activeTab={activeTab}
              handleActiveTab={handleActiveTab}
            />
          </TabsWrapper>
        )}
        <TableWrapper>
          <Table />
        </TableWrapper>
      </Container>
    </Navbar>
  );
};

export default TrackingContainer;
